module.exports = __webpack_public_path__ + "files/643db78ae12d11b9e705f9cc41b2dc60.png";